export enum OrderByOptions {
  BUDGET = 'BUDGET_',
  UPDATED = 'UPDATED_',
  PUBLISHED = 'PUBLISHED_',
}